import React from 'react';
import { Carousel } from '@mantine/carousel';
import { MediaInfo } from '~/src/types/posts';

interface MediaCarouselProps {
  media: MediaInfo[];
  onMediaClick: (mediaIndex: number) => void;
}

export default function MediaCarousel({ media, onMediaClick }: MediaCarouselProps) {
  return (
    <div style={{ margin: '0 1rem 1rem 1rem' }}>
      <Carousel
        withIndicators={media.length > 1}
        height={280}
        style={{
          borderRadius: '12px',
          overflow: 'hidden',
          boxShadow: '0 2px 8px  rgba(255, 255, 255, 0.9)',
        }}
        styles={{
          control: {
            backgroundColor: 'var(--global-gray-lighter-8)',
            border: 'none',
            color: 'var(--global-gray-darker-5)',
            borderRadius: '50%',
            width: '32px',
            height: '32px',
            '&:hover': {
              backgroundColor: 'var(--global-gray-lighter-8)',
            },
          },
          indicator: {
            backgroundColor: 'var(--global-gray-lighter-5)',
            width: '8px',
            height: '8px',
            '&[data-active]': {
              backgroundColor: 'white',
            },
          },
        }}
        controlSize={10}
        withControls={media.length > 1 && window.innerWidth > 768}
      >
        {media.map((mediaItem, index) => (
          <Carousel.Slide key={mediaItem.id.toString()}>
            <div
              style={{
                position: 'relative',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'var(--global-gray-lighter-7)',
              }}
            >
              <img
                src={mediaItem.main_url}
                alt={`Post image ${index + 1}`}
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                  cursor: 'pointer',
                }}
                onClick={() => onMediaClick(index)}
                onError={(e) => {
                  e.currentTarget.src = mediaItem.main_url;
                }}
              />
            </div>
          </Carousel.Slide>
        ))}
      </Carousel>
    </div>
  );
}
